import React from 'react'
import { DatePicker, Form } from 'antd'
import { Controller } from 'react-hook-form'

export interface DateFieldProps {
  fieldname: string
  isRequired?: boolean
  label?: string
  validate?: any
  validMessage?: any
  className?: string
  control: any
  initValue?: any
  rules?: any
  iProps?: any
  onChangeRadio?: any
  prefix?: any
  hintMessage?: string
  onDateChange: any
}

const DateField: React.FunctionComponent<DateFieldProps> = ({
  fieldname,
  isRequired,
  label,
  validate,
  validMessage,
  className,
  control,
  initValue,
  rules,
  iProps,
  hintMessage,
  prefix,
  onDateChange,
}: DateFieldProps) => {
  return (
    <Form.Item
      required={isRequired ?? false}
      validateStatus={validate}
      help={validMessage}
      label={label}
      valuePropName="checked"
      className={className}
    >
      <Controller
        rules={rules}
        name={fieldname}
        control={control}
        defaultValue={initValue ?? ''}
        render={({ field: { onChange, value } }) => (
          <>
            <div className="select_prefix">{prefix}</div>
            <DatePicker
              style={{ width: '100%' }}
              value={value}
              className="formControl"
              onChange={(e) => {
                onChange(e)
                onDateChange(e)
              }}
              {...iProps}
            />
            {hintMessage && <div className="hint_text">{hintMessage}</div>}
          </>
        )}
      />
    </Form.Item>
  )
}

export default DateField
